export const questions: Array<[string, string]> = [
  [
    'Professional level?',
    'Mechanical engineers, industrial technicians, manufacturing professionals, maintenance specialists, equipment operators worldwide.',
  ],
  [
    'Content depth?',
    'From engineering fundamentals through advanced mechanical design, materials science, thermodynamics, manufacturing processes, machinery operation, and reliability engineering. Scales from foundational to professional expertise.',
  ],
  ['International?', 'Yes. Universal mechanical engineering principles with guidance for regional industrial codes and standards.'],
  ['Editable?', 'Yes. Professional-grade PDFs for reference and technical documentation.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  [
    'What makes it different?',
    'Complete system: 6 coherent volumes, 5 exclusive bonuses, essential formulas, machinery handbook, troubleshooting guide, materials selection resource, technical dictionary. Everything designed so you never struggle with technical understanding again.',
  ],
  ['Not satisfied?', '7-day refund. 100% money back, no questions.'],
];
